import { useMemo } from "react";
import { getAuditsMaintenance } from "@/common/services/audits-maintenances.api";
import { useQuery } from "@tanstack/react-query";
import { useToastContext } from "@/common/components/ui/toast/toast.context";
import { useCompanyStore } from "@/common/states/store/Company";
import { useAuditMaintenanceState } from "@/common/states/store/slices/auditsMaintenanceSlice";

export const useGetAuditsVehiclesMaintenance = () => {
  const { notifyError } = useToastContext();
  const company = useCompanyStore((state) => state.company);
  const currentRegion = useCompanyStore((state) => state.selectedRegion);
  const currentUF = useCompanyStore((state) => state.selectedUf);
  const { filters, page } = useAuditMaintenanceState()
  
  const queryKey = useMemo(
    () => [
      'audits-vehicles-maintenance',
      company?.companyId,
      filters,
      page,
      currentRegion,
      currentUF
    ], 
      [company?.companyId, filters, page, currentRegion, currentUF]
  );

  const { data, isLoading, refetch } = useQuery({
    queryKey,
    queryFn: async () => {
      const response = await getAuditsMaintenance({ page, status: String(filters.status), search: filters.search });
      if (!response.ok) {
        notifyError("Erro ao buscar auditorias de manutenções de veículos");
        return { audits: [], totalItems: 0 };
      }
      return {
        audits: response.data,
        totalItems: response.totalItems,
      };
    },
    refetchOnWindowFocus: false,
  });

  return {
    audits: data?.audits ?? [],
    totalItems: data?.totalItems ?? 0,
    isLoading,
    refetch,
  };
}
